import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { UnauthorizedComponent } from '@app/auth/components/unauthorized/unauthorized.component';

const routes: Routes = [{ path: 'unauthorized', component: UnauthorizedComponent }];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false, preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
